import { jsx } from "react/jsx-runtime";
function BlankBox({ children }) {
  return /* @__PURE__ */ jsx("span", { className: "inline-flex items-center justify-center border-gray-300 bg-white border-2 rounded-md h-10 px-2 mx-1 text-center min-w-[40px]", children });
}
export {
  BlankBox as default
};
//# sourceMappingURL=blank-box.js.map
